// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__nlwID","range":"MonthRangeSwitch_range__3QmuT","disabled":"MonthRangeSwitch_disabled__1ygKH"};